<template>
  <div
    @mouseenter="mouseEnter = openOrCloseDropDown()"
    @mouseleave="mouseEnter = false"
    :class="[{ 'mouse-enter': mouseEnter, 'mouse-leave': !mouseEnter }]"
  >
    <md-button
      :md-ripple="false"
      data-v-step="0"
      md-elevation="0"
      class="md-icon-button dropdown-toggle menu-hamburguer"
      data-cy="tbHamburgerHeader"
      @click="toggleMenu"
    >
      <md-icon>menu</md-icon>
    </md-button>
    <div
      class="menu-container"
      :class="[{ 'show-menu': show, 'hide-menu': !show }]"
      @click="toggleMenu"
    >
    </div>
      <div
        class="my-drop"
        :class="[{ 'show-menu': show, 'hide-menu': !show }]"
      >
        <router-link
          class="dropdown-item profile-icon"
          :to="`/s-app/profile-page/${userId}`"
          data-cy="profileLink"
          @click.native="close"
        >
          <SUserAvatar
            id="header-icon"
            :myUser="user"
            size="small"
            data-v-step="2"
            :isProfileAvatar="true"
            :tryModeratorBadge="false"
          />
          <span>My profile</span>
        </router-link>

        <div class="swampum--pointsBalance">
          <router-link class="dropdown-item" to="/s-app/points-history" data-cy="pointsAreaLink" @click.native="close">
            <div class="swampum--pointsBalanceInfo">
              <!-- <md-icon id="header-icon">hexagon</md-icon> -->
              <p>Points</p>
              <div>
                {{ getMyPointsBalance }}
                <img class="mb-2" src="/img/Polygon_7.svg" alt="Swampum" width="10px" height="10px"/>
              </div>
            </div>
          </router-link>
        </div>

        <router-link
          class="dropdown-item"
          to="/s-app/invite-friends"
          data-cy="tbInviteFriend"
          @click.native="close"
        >
          <md-icon id="header-icon">group_add</md-icon>
          <span>Invite friends</span>
        </router-link>
        <hr class="line-header" />
        <a
          class="dropdown-item"
          @click.prevent="openNewItemModal"
          data-cy="tbPostItem"
        >
          <md-icon id="header-icon">control_point</md-icon>
          <span>Post item</span>
        </a>
        <hr class="line-header" />
        <router-link
          class="dropdown-item"
          to="/s-app/feed"
          @click.native="close"
        >
          <md-icon id="header-icon">feed</md-icon>
          <span>Feed</span>
        </router-link>
        <router-link
          class="dropdown-item"
          to="/s-app/groups"
          data-cy="linkMembershipPage"
          @click.native="close"
        >
          <md-icon id="header-icon">groups</md-icon>
          <span>Groups</span>
        </router-link>
        <router-link
          class="dropdown-item"
          to="/s-app/message-center"
          data-cy="tbLinkMessageCenter"
          @click.native="close"
        >
          <md-icon id="header-icon">question_answer</md-icon>
          <span>Message center</span>
        </router-link>
        <router-link
          class="dropdown-item"
          to="/s-app/item-activity"
          data-cy="tbActivityPageHeaderBtn"
          @click.native="close"
        >
          <md-icon id="header-icon">history</md-icon>
          <span>Item activity</span>
        </router-link>
        <hr class="line-header" />
        <router-link
          class="dropdown-item"
          data-toggle="tooltip"
          data-placement="top"
          to="/s-app/garage-sales"
          :data-html="true"
          @click.native="close"
        >
          <md-icon id="header-icon">warehouse</md-icon>
          <span>Garage sales</span>
        </router-link>
        <a
          class="dropdown-item"
          href="http://blog.swampum.com/"
          target="_blank"
          rel="noopener"
        >
          <md-icon id="header-icon">campaign</md-icon>
          <span>Blog</span>
        </a>
        <router-link
          class="dropdown-item"
          to="/s-app/help-center"
          data-cy="helpButtonMore"
          @click.native="close"
        >
          <md-icon id="header-icon">help_outline</md-icon>
          <span>Help center</span>
        </router-link>
        <router-link
          class="dropdown-item"
          to="/s-app/contact-us"
          data-cy="tbSupportButton"
          @click.native="close"
        >
          <md-icon id="header-icon">contact_mail</md-icon>
          <span>Contact us</span>
        </router-link>
        <router-link
          class="dropdown-item"
          to="/s-app/terms-and-conditions"
          @click.native="close"
        >
          <md-icon id="header-icon">gavel</md-icon>
          <span>Terms/conditions</span>
        </router-link>
        <a class="dropdown-item logout-icon" @click.prevent="logout" data-cy="logoutButton">
          <md-icon id="logout-icon" class="logout-icon">logout</md-icon>
          <span class="logout-icon">Log out</span>
        </a>
      </div>

  </div>
</template>

<script>
import Global from "@/constants/Global";
import UserHelperVue from "@/mixins/UserHelper.vue";
import Auth from "@/modules/Auth.js";
import { mapActions } from "vuex";
import SUserAvatar from '../../material-components/atoms/SUserAvatar.vue';

export default {
  name: "SHeaderMobileMenu",
  components: {
    SUserAvatar,
  },
  props: ["userId"],
  mixins: [UserHelperVue],
  data() {
    return {
      mouseEnter: false,
      show: false,
      userData: null
    };
  },
  computed: {
    comingSoonTooltip() {
      return "<p>Coming soon<p>";
    },
    getMyPointsBalance() {
      if (this.loggedUser) {
        if (this.myPointsum === undefined) {
          return 0;
        }

        return this.myPointsum;
      }
      return 'User disconnected';
    }
  },
  methods: {
    ...mapActions(["endSession"]),
    logout() {
      sessionStorage.clear();
      this.endSession();
      Auth.deauthenticateUser();
      this.$parent.$parent.$parent.clearLastInteraction();
      localStorage.removeItem("user_id");
      console.log("passei2");
      this.$route.path !== "/" && this.$router.push("/");
      location.reload();
    },
    close() {
      this.$emit("changeKey");
      this.toggleMenu()
    },
    toggleMenu() {
      this.show = !this.show
    },
    openNewItemModal() {
      $("#new-item").modal("show");
    },
    openInviteModal() {
      $("#share-with-friends").modal("show");
    },
    openOrCloseDropDown() {
      return !Global.checkDevice();
    },
  },
  watch: {
    loggedUser(){
      this.userData = this.loggedUser
    }
  }
};
</script>

<style scoped>

.mouse-leave .md-button {
  background-color: white !important;
}
</style>

<style lang="scss" scoped>
hr {
  margin-top: 0.2em;
  margin-bottom: 0.2em;
}

.logout-icon, #logout-icon {
  display: flex;
  padding-right: 0;
  margin-top: -2px;
  margin-right: 0.4em;
  color: red !important;
}
.profile-icon {
  display: flex;
  align-items: center;
}
.menu-container {
  position: absolute;
  z-index: 99;
  transition: 1s ease;
  top: -8px;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.6);
}
.menu-container.show-menu {
  left: -10px;
  display: block;
}
.menu-container.hide-menu {
  display: none;
}
.my-drop.show-menu {
  left: -10px;
}
.my-drop.hide-menu {
  left: -57vw;
}
.my-drop {
  padding: 20px;
  top: -8px;
  height: 100vh;
  width: 54vw;
  z-index: 9999;
  position: absolute;
  left: -10px;
  transition: 0.6s ease;
  background-color: white;
}
.mouse-enter .md-button {
  background-color: $primary !important;
}
.md-button {
  border: 1px solid #e0e0e0;
  border-radius: 5px !important;
}
.mouse-leave .md-icon {
  color: $primary !important;
}
.mouse-enter .md-icon {
  color: white !important;
}
</style>

<style lang="scss" scoped>
#header-icon {
  color: $header-icon-color !important;
  margin-top: -2px;
  margin-right: 0.4em;
}
.line-header {
  width: 90%;
  color: rgba(0, 0, 0, 0.2);
}

.swampum--pointsBalance {
  width: 85%;

  border-radius: 0.75rem;
  background-color: $grey;
  margin: 0 1rem;
  padding: 0;
}

.swampum--pointsBalanceInfo {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  p {
    letter-spacing: 1.25px;
    margin: 0;

    color: $black;
  }

  div {
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;

    font-weight: bold;
    font-size: 14px;

    color: $black;
  }
}

.dropdown-item {
  margin-top: 0.4rem;
  cursor: pointer;
}
</style>

<style lang="scss" scoped>
.my-drop::before {
  position: absolute;
  content: "";
  top: -1px;
  left: 10px;
  transform: translateY(-100%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 13px solid $primary;
}
</style>

<!-- Header drop menu style -->
<style lang="scss">
#drop-menu .show {
  width: 245px !important;
  margin-top: 0.95em;
  border: 1px solid $primary;
}
#drop-menu a {
  color: $black !important;
}
#drop-menu span {
  margin-left: 0.5rem;
  text-align: center;
  font-size: 14px;
  letter-spacing: 1.25px;
}
#drop-menu a:active {
  background-color: $primary;
}
.menu-hamburguer {
  margin: 0;
}
a,
a:hover {
  text-decoration: none !important;
}
</style>
